import * as cache from './cache';
export const getState = state => state.toast;
export const getToasts = state => getState(state).map(cache.get);
//# sourceMappingURL=selectors.js.map